/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_List_EmptyInputs */

const vi_product_lot_list_empty = /** @type {(inputs: Product_Lot_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có lô nào`)
};

/**

* @param {Product_Lot_List_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_list_empty = /** @type {((inputs?: Product_Lot_List_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_List_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_list_empty(inputs)
});